export default __webpack_public_path__ + "static/hero-residences1-c650414cdb660069ddaf0e63752091c9.jpg";